import React from "react"
import "./style.scss"

const Takeaways = (props) => {
  const { takeaways, isAuthenticated, userAccess } = props

  return (
    <div className="topic-takeaways">
      <h2>
        <span>TOP </span>
        <span>TAKEAWAYS - </span>
      </h2>
      <ul>
        {takeaways.map((takeaway, idx) => {
          const isFirst2TakeAway = idx <= 1
          const canView =
            (isAuthenticated && userAccess === "FULL") || isFirst2TakeAway

          return (
            <li key={idx} data-cy="vendor-takeaway">
              <span data-isauthorized={!!canView}> {takeaway.value} </span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Takeaways
